//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LandMap from "@/components/LandMap";
import { mapActions, mapState } from "vuex";
export default {
  name: "OrderLand",
  data() {
    return {
      landList: [], // 所有的地块
      trajectoryList: [], // 所有的轨迹块
      workNum: "",
      workTypeId: "",
      mapTopInfoOptions: {
        hasAll: true,
        isFilter: true,
        data: [],
        hasData: true,
      },
    };
  },
  props: {
    orderId: {
      type: String,
    },
  },
  components: {
    LandMap,
  },
  computed: {
    ...mapState("map", {
      showTrajectory: (state) => state.showTrajectory,
    }),
  },
  watch: {
    showTrajectory(n) {
      if (n) {
        if (this.workTypeId && this.showTrajectory) {
          let { workTypeId, workNum, orderId } = this;
          let params = { workTypeId, workNum, orderId: orderId };
          this.getOrderTrajectory(params);
        }
      }
    },
  },
  created() {
    this.getOrderLandList({ orderId: this.orderId });
    // this.getWorkTypeTrajectory();
    this.getWorkTypeListFilter();
    this.$bus.$on("filterMap", this.handleFilterMap);
  },
  destroyed() {
    this.$bus.$off("filterMap");
  },
  methods: {
    ...mapActions("map", ["changeShowTrajectory"]),
    /**
     * @descripttion: 获取地块信息
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:30:34
     */
    getOrderLandList(params) {
      this.$http.order.getOrderLandList(params).then((res) => {
        this.landList = res.data;
      });
    },
    /**
     * @descripttion: 获取轨迹块
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:39:56
     */
    getOrderTrajectory(params) {
      this.$http.order.getOrderTrajectory(params).then((res) => {
        this.trajectoryList = res.data;
      });
    },
    /**
     * @descripttion: 获取地块信息
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:30:34
     */
    getWorkTypeListFilter() {
      this.$http.order
        .getWorkTypeListFilter({ orderId: this.orderId })
        .then((res) => {
          let data = res.data;
          data.forEach((item) => {
            item.id = `${item.workTypeId}-${item.workNum}`;
            item.name = item.workTypeName;
          });
          data.unshift({
            id: "11111",
            name: "全部(当前最新)",
            icon: "iconfont icon-quanbufenlei",
          });
          this.mapTopInfoOptions.data = data;
        });
    },
    /**
     * @descripttion: 筛选地图
     * @Author: juanjuanhui
     * @Date: 2021-12-07 13:54:40
     * @param {*} data 筛选当前项内容
     */
    handleFilterMap(data) {
      this.trajectoryList = [];
      let { workTypeId, workNum } = data;
      this.workNum = workNum;
      this.workTypeId = workTypeId;
      let params = { workTypeId, workNum, orderId: this.orderId };
      this.getOrderLandList(params);
      this.changeShowTrajectory(false);
    },
  },
};
